var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-8"},[_c('v-row',[_c('v-spacer'),_c('v-col',{attrs:{"cols":"12","lg":_vm.columnWidth}},[_c('v-card',{staticClass:"pa-5",attrs:{"elevation":"2"}},[_vm._t("default")],2)],1),_c('v-spacer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }